"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asechDocs = void 0;
var asechDocs = {
  name: 'asech',
  category: 'Trigonometry',
  syntax: ['asech(x)'],
  description: 'Calculate the inverse secant of a value.',
  examples: ['asech(0.5)'],
  seealso: ['acsch', 'acoth']
};
exports.asechDocs = asechDocs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/cjs/expression/embeddedDocs/function/trigonometry/asech.js
// module id = a394
// module chunks = 23